import { FWNElement } from './bases/FWNElement'

class HeroUnitElement extends FWNElement {
  height = '75vh'
  width = '100%'

  override render(): void {
    import('@embed/herounitRender').then(({ herounitRender }) => {
      if (this.shadowRoot) {
        herounitRender({
          target: this.shadowRoot,
          widgetId: this.widgetId,
          widgetParams: {
            height: this.height,
            width: this.width,
            ...this.getAttributes(),
          },
        })
      }
    })
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'fw-herounit': Record<string, string>
    }
  }
}

if (!customElements.get('fw-herounit')) {
  customElements.define('fw-herounit', HeroUnitElement)
}
